import base from './base'

let controller = 'role'
let action = null

const Role = {
  async listRoles (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    querys.isReserved = query.isReserved !== null ? query.isReserved ? true : false : null
    action = 'ListRoles'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async addRole (request) {
    let model = {
      type: request.type || null,
      name: request.name || null,
      isReserved: request.isReserved || null,
      parent: request.parent || null
    }
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async updateRole (request) {
    let model = {
      id: request.id || request.tid || null,
      type: request.type || null,
      name: request.name || null,
      isReserved: request.isReserved || null,
      parent: request.parent || null
    }
    if (!model.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `Update/${model.id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async deleteRole (roleId) {
    if (!roleId) {
      throw new Error('RoleId为空')
    }
    action = `Delete/${roleId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }
}

export default Role